require("./brokerConvenienceTestView.scss");
require("./brokerConvenienceTestView.override.scss");

// @vendors
const React = require("react");
const PropTypes = require("prop-types");
const { connect } = require("react-redux");
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const OKModal = require('components/commons/OKModal/OKModal');

// @components

const BrokerConvenienceTestHeader = require("./brokerConvenienceTestHeader/brokerConvenienceTestHeader");
const BrokerConvenienceTestContainer = require("./brokerConvenienceTestContainer/brokerConvenienceTestContainer");
const BrokerConvenienceTestSuccess = require("./brokerConvenienceTestSuccess/brokerConvenienceTestSuccess");
const BrokerConvenienceTestFailure = require("./brokerConvenienceTestFailure/brokerConvenienceTestFailure");

// @actions
const screenActions = require('actions/screen');
const BrokerConvenienceMiFIDTestActions = require('mifid/actions/brokerConvenienceMiFIDTest');
const BrokerConvenienceMiFIDTestStepOmitTestAction = require('mifid/actions/brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStepOmitTest');

// @utilites
const classNames = require("classnames");
const PersonalDataHelper = require('utilities/personalDataHelper');

// @constants
const { BROKER_PG_URL } = require('constants/index');
const { MAX_ATTEMPTS } = require('mifid/constants/constants');

//tagging
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const { PROC_BROKER_CONVENIENCE_TEST } = require('utilities/tagging');
const { buildTags } = require("../../utilities/mifidTaggingHelper");
class BrokerConvenienceTestView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            testStatus: "inProgress",
            confirmationStatus: ""
        };

        this.handleFinishStep = this.handleFinishStep.bind(this);
        this.onTestResultsConfirm = this.onTestResultsConfirm.bind(this);
        this.handleOmitContinue = this.handleOmitContinue.bind(this);
    }

    componentDidMount() {
        const { hideAppHeader, validatePreviousTest } = this.props;
        hideAppHeader();
        validatePreviousTest();
    }

    componentWillUpdate() {
        const { validatePreviousTest } = this.props;
        validatePreviousTest();
    }

    componentWillUnmount() {
        this.props.showAppHeader();
    }

    handleFinishStep () {
        this.setState({ testStatus: "testSuccess" });
    }

    onTestResultsConfirm() {
        this.setState({ confirmationStatus: "success" });
    }

    handleOmitContinue() {
        const clientEmail = PersonalDataHelper.getEmail(this.props.immProfileFields);
        this.props.onOmit();
        this.props.onOmitContinue(clientEmail);
    }

    goToFirstStep() {
        const { immBrokerConvenienceMiFIDTest, onReviewingTest, goToStep } = this.props;
        const immTest = immBrokerConvenienceMiFIDTest.get("test");
        const immQuestions = immTest.getIn(['testToEvaluate', 'test','question'])
        const immQuestionZero = immQuestions.find(immQuestion => immQuestion.get('id') ==='200');
        onReviewingTest()
        if(!!immQuestionZero) {
            goToStep(1, 0)
        } else {
            goToStep(0, 0)
        }
    }

    render() {
        const {
            handleNextStep,
            handlePreviousStep,
            immBrokerConvenienceMiFIDTest,
            validateWithLastTestAndContinue,
            hideTestDifferenceModal,
            changeDisabledButton,
            history,
            getCurrentTestScore,
            flagBasedFeatures,
            immProfileFields,
            continueWithDisapprovedTest,
            showConfirmationStep,
            showModalForQuestion204,
            goToConfirmationStep,
            showProfExpWarningModal,
            onCancelTest
        } = this.props;

        const immTest = immBrokerConvenienceMiFIDTest.get("test");
        const disabledButton = immBrokerConvenienceMiFIDTest.get("disabledButton");
        const testStatus = immTest.get("testStatus");
        const attempts = immTest.get("attempts");
        const immSchema = immTest.get("schema");
        const immTestState = immTest.get("testState");
        const currentStepCategory = immTestState.get("currentStepCategory");
        const currentStepSubCategory = immTestState.get("currentStepSubCategory");
        const categoriesLength = immSchema.get("categories").size;
        const isReviewingTest = immBrokerConvenienceMiFIDTest.get('isReviewingTest');
        const showProfessionalExperienceModal = immBrokerConvenienceMiFIDTest.get('showProfessionalExperienceModal')
        const showProfessionalExperienceModalWarning = immBrokerConvenienceMiFIDTest.get('showProfessionalExperienceModalWarning')
        const lastSubcategoryLenght= immSchema.getIn([
            "categories",
            categoriesLength - 1,
            "subCategories",
        ]).size;

        const firstStepOnFirstTime = [currentStepCategory === 0, currentStepSubCategory === 0].every((e) => e === true)
        const firstStepOnReviewingTest = [currentStepCategory === 1, currentStepSubCategory === 0, isReviewingTest].every((e) => e === true)
        const isFirstStep =  firstStepOnFirstTime || firstStepOnReviewingTest;
        const isLastStep = currentStepCategory === categoriesLength-1 && currentStepSubCategory === lastSubcategoryLenght - 1;

        const viewClassName = classNames(
            "br-convenience-test-view",
            "br-convenience-test-view--padding"
        );

        const immCategories = immSchema.get("categories");
        const cancelPath = immBrokerConvenienceMiFIDTest.get('cancelPath');

        const tags = buildTags({
            immCategories,
            currentStepCategory,
            currentStepSubCategory,
        });

        const onReviewTestSuccess = () => {
            this.goToFirstStep()
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onReviewTestOTP')
        }

        const onConfirmOtp = () => {
            this.props.finishTest()
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onConfirmOTP')
        }

        const onAfterOpenModalAttempts = () => {
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onOpenModalMaxAttempts')
        }

        const onCloseModalAttempts = () => {
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onCloseModalMaxAttempts')
            history.push(BROKER_PG_URL)
        }

        const onAfterOpenModalProfessionalExperience = () => {
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onAfterOpenModalProfExp');
        }

        const onCloseModalProfessionalExperience = () => {
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onCloseModalProfExp');
            showModalForQuestion204(false);
        }

        const onPrimaryButtonClickProfessionalExperience = () => {
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onClickButtonModalProfExp');
            validateWithLastTestAndContinue();
        }

        const onAfterOpenModalProfessionalExperienceWarning = () => {
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onAfterOpenModalProfExpWarning')
        }

        const onCloseModalProfessionalExperienceWarning = () => {
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onCloseModalProfExpWarning')
            showProfExpWarningModal(false)
        }

        const onPrimaryButtonClickProfessionalExperienceWarning = () => {
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onClickButtonModalProfExpWarning')
            showProfExpWarningModal(false)
            showConfirmationStep()
        }

        const onSecondaryButtonClickProfessionalExperienceWarning = () => {
            taggingEventHandled(PROC_BROKER_CONVENIENCE_TEST, 'onClickSecondaryButtonModalProfExpWarning')
            showProfExpWarningModal(false)
        }

        const modalContent = (
            <React.Fragment>
                <div className="br-convenience-test-view-content__modal-tittle">
                    <FormattedText value="broker-brokerMifidTestAttemptsModal_title" />
                </div>
                <div className="br-convenience-test-view-content__modal-content">
                    <p className="br-convenience-test-view-content__modal-content--text">
                        <FormattedText value="broker-brokerMifidTestAttemptsModal_content" />
                    </p>
                </div>

            </React.Fragment>
        );

        const modalProfessionalExperience = (
            <React.Fragment>
                <div className="br-convenience-test-view-content__modal-tittle">
                    <FormattedText value="broker-brokerMifidTestProfessionalExperienceModal_title" />
                </div>
                <div className="br-convenience-test-view-content__modal-content">
                    <p className="br-convenience-test-view-content__modal-content--text">
                        <FormattedText value="broker-brokerMifidTestProfessionalExperienceModal_content" />
                    </p>
                </div>
            </React.Fragment>
        );

        const modalProfessionalExperienceWarning = (
            <React.Fragment>
                <div className="br-convenience-test-view-content__warningModal-tittle">
                    {<FormattedText value="broker-brokerMifidTestProfessionalExperienceWarningModal_title" />}
                </div>
                <div className="br-convenience-test-view-content__modal-content">
                    <p className="br-convenience-test-view-content__warningModal-content--text">
                        {<FormattedText value="broker-brokerMifidTestProfessionalExperienceWarningModal_content" />}
                    </p>
                </div>
            </React.Fragment>
        );
        return (
            <div className={viewClassName}>
                <div className="container-fluid">
                    <div className="row">
                        <BrokerConvenienceTestHeader history={history}/>
                    </div>
                </div>
                <div className="row">
                    <div
                        id="printable-wizard"
                        className="br-convenience-test-view-content"
                    >
                        {testStatus === "inProgress" && (
                            <div>
                                <OKModal
                                    content={modalContent}
                                    isOpen={(attempts === MAX_ATTEMPTS) && !__CONTACT_CENTER__}
                                    primaryButtonText={formatText('broker-brokerMifidTestAttemptsModal_CTA')}
                                    footerType="action"
                                    onPrimaryButtonClick={onCloseModalAttempts}
                                    onCloseCallback={onCloseModalAttempts}
                                    onAfterOpen={onAfterOpenModalAttempts}

                                />
                                <OKModal
                                    content={modalProfessionalExperience}
                                    isOpen={showProfessionalExperienceModal}
                                    primaryButtonText={formatText('broker-brokerMifidTestProfessionalExperienceModal_primaryButton')}
                                    footerType="action"
                                    onCloseCallback={onCloseModalProfessionalExperience}
                                    onPrimaryButtonClick={onPrimaryButtonClickProfessionalExperience}
                                    onAfterOpen={onAfterOpenModalProfessionalExperience}
                                />
                                <OKModal
                                    content={modalProfessionalExperienceWarning}
                                    isOpen={showProfessionalExperienceModalWarning}
                                    primaryButtonText={formatText('broker-brokerMifidTestProfessionalExperienceWarningModal_primaryButton')}
                                    secondaryButtonText={formatText('broker-brokerMifidTestProfessionalExperienceWarningModal_secondaryButton')}
                                    footerType="navigation"
                                    onCloseCallback={onCloseModalProfessionalExperienceWarning}
                                    onPrimaryButtonClick={onPrimaryButtonClickProfessionalExperienceWarning}
                                    onAfterOpen={onAfterOpenModalProfessionalExperienceWarning}
                                    onSecondaryButtonClick={onSecondaryButtonClickProfessionalExperienceWarning}

                                />
                                <BrokerConvenienceTestContainer
                                    immCategories={immCategories}
                                    currentStepCategory={currentStepCategory}
                                    currentStepSubCategory={currentStepSubCategory}
                                    isFirstStep={isFirstStep}
                                    isLastStep={isLastStep}
                                    handleNextStep={handleNextStep}
                                    handlePreviousStep={handlePreviousStep}
                                    handleSelectedRadio={this.handleSelectedRadio}
                                    handleClickAccordion={this.handleClickAccordion}
                                    handleSelectAccordionButton={this.props.handleSelectAccordionButton}
                                    handleFinishStep={validateWithLastTestAndContinue}
                                    goToConfirmationStep={goToConfirmationStep}
                                    hideTestDifferenceModal={hideTestDifferenceModal}
                                    updateAnswer={this.props.updateAnswer}
                                    handleOmitContinue={this.handleOmitContinue}
                                    disabledNextButton={disabledButton}
                                    changeDisabledButton={changeDisabledButton}
                                    cancelPath={cancelPath}
                                    getCurrentTestScore={getCurrentTestScore}
                                    onClickCancel={onCancelTest}
                                    currentCategoryName={tags.currentCategoryTag}
                                    currentSubCategoryName={tags.currentSubCategoryTag}
                                    currentStep={tags.currentStep}
                                    history={history}
                                />
                            </div>
                        )}

                        {testStatus === "testSuccess" && (
                            <BrokerConvenienceTestSuccess
                                confirmationStatus={immTest.get('confirmationStatus')}
                                onTestResultsConfirm={() => onConfirmOtp()}
                                immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                                goToFinishTest={this.props.goToFinishTest}
                                goToFirstStep={() => onReviewTestSuccess()}
                                getCurrentTestScore={getCurrentTestScore}
                                flagBasedFeatures={flagBasedFeatures}
                                history={history}
                                immProfileFields={immProfileFields}
                            />
                        )}
                        {testStatus === "testFail" && (
                            <BrokerConvenienceTestFailure
                                confirmationStatus={this.state.confirmationStatus}
                                onTestResultsConfirm={this.onTestResultsConfirm}
                                immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                                immProfileFields={immProfileFields}
                                goToFirstStep={() => this.goToFirstStep()}
                                continueWithDisapprovedTest={continueWithDisapprovedTest}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

BrokerConvenienceTestView.propTypes = {
    handleNextStep: PropTypes.func.isRequired,
    handlePreviousStep: PropTypes.func.isRequired,
    hideAppHeader: PropTypes.func.isRequired,
    showAppHeader: PropTypes.func.isRequired,
    goToFinishTest: PropTypes.func.isRequired,
    goToConfirmationStep: PropTypes.func.isRequired,
    validateWithLastTestAndContinue: PropTypes.func.isRequired,
    hideTestDifferenceModal: PropTypes.func.isRequired,
    finishTest: PropTypes.func.isRequired,
    onOmit: PropTypes.func.isRequired,
    onOmitContinue: PropTypes.func.isRequired,
    goToStep: PropTypes.func.isRequired,
    onReviewingTest: PropTypes.func.isRequired,
    onCancelTest: PropTypes.func.isRequired,
    currentCategoryName:PropTypes.func,
    currentSubCategoryName: PropTypes.func,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    changeDisabledButton: PropTypes.func.isRequired,
    validatePreviousTest: PropTypes.func.isRequired,
    getCurrentTestScore: PropTypes.func.isRequired,
    continueWithDisapprovedTest: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
};

module.exports = connect(
    state => ({
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immProfileFields: state.profile,
        flagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        hideAppHeader: screenActions.hideAppHeader,
        showAppHeader: screenActions.showAppHeader,
        handleNextStep: BrokerConvenienceMiFIDTestActions.goToForwardStep,
        handlePreviousStep: BrokerConvenienceMiFIDTestActions.goToPreviousStep,
        handleSelectAccordionButton: BrokerConvenienceMiFIDTestActions.updateAnswer,
        updateAnswer: BrokerConvenienceMiFIDTestActions.updateAnswer,
        goToConfirmationStep: BrokerConvenienceMiFIDTestActions.goToConfirmationStep,
        hideTestDifferenceModal: BrokerConvenienceMiFIDTestActions.hideTestDifferenceModal,
        validateWithLastTestAndContinue: BrokerConvenienceMiFIDTestActions.validateWithLastTestAndContinue,
        goToFinishTest: BrokerConvenienceMiFIDTestActions.goToFinishTest,
        goToStep: BrokerConvenienceMiFIDTestActions.goToStep,
        onReviewingTest: BrokerConvenienceMiFIDTestActions.onReviewingTest,
        onCancelTest: BrokerConvenienceMiFIDTestActions.onCancelTest,
        finishTest: BrokerConvenienceMiFIDTestActions.finish,
        onOmit: BrokerConvenienceMiFIDTestActions.omit,
        onOmitContinue: BrokerConvenienceMiFIDTestStepOmitTestAction.confirm,
        changeDisabledButton: BrokerConvenienceMiFIDTestActions.changeDisabledButton,
        validatePreviousTest: BrokerConvenienceMiFIDTestActions.validatePreviousTest,
        getCurrentTestScore: BrokerConvenienceMiFIDTestActions.getCurrentTestScore,
        continueWithDisapprovedTest: BrokerConvenienceMiFIDTestActions.continueWithDisapprovedTest,
        showConfirmationStep: BrokerConvenienceMiFIDTestActions.showConfirmationStep,
        showModalForQuestion204: BrokerConvenienceMiFIDTestActions.showModalForQuestion204,
        showProfExpWarningModal: BrokerConvenienceMiFIDTestActions.showProfExpWarningModal,
    },
)(BrokerConvenienceTestView);
